var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sendType == "TEXT" && _vm.bodyText
    ? _c("div", { staticClass: "chat-text" }, [_vm._v(_vm._s(_vm.bodyText))])
    : _vm.sendType == "FILE" && _vm.file
    ? _c("div", { staticStyle: { width: "100%" } }, [
        RegExp(/image\/*/).test(_vm.file.fileContentType)
          ? _c("img", {
              staticClass: "rcs-radius-image",
              attrs: { src: _vm.file.fileUrl }
            })
          : _vm._e(),
        _vm._v(" "),
        RegExp(/video\/*/).test(_vm.file.fileContentType)
          ? _c("video", {
              staticClass: "media",
              attrs: { src: _vm.file.fileUrl, controls: "controls" }
            })
          : _vm._e(),
        _vm._v(" "),
        RegExp(/audio\/*/).test(_vm.file.fileContentType)
          ? _c("video", {
              staticClass: "media",
              attrs: { src: _vm.file.fileUrl, controls: "controls" }
            })
          : _vm._e(),
        _vm._v(" "),
        RegExp(/application\/*/).test(_vm.file.fileContentType)
          ? _c(
              "a",
              { staticClass: "file-con", attrs: { href: _vm.file.fileUrl } },
              [_vm._v(_vm._s(_vm.file.fileName))]
            )
          : _vm._e()
      ])
    : _vm.sendType == "LOCATION" && _vm.location
    ? _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c("MapItem", {
            attrs: {
              uniqueKey: _vm.createTime + "map",
              latitude: _vm.location.latitude,
              longitude: _vm.location.longitude,
              address: _vm.location.address
            }
          })
        ],
        1
      )
    : _vm.sendType == "REPLY" && _vm.reply
    ? _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", { staticClass: "chat-text", staticStyle: { flex: "1" } }, [
          _vm._v(_vm._s(_vm.reply.replyName))
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-570dfe04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-570dfe04","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/chatRoom/messageType.vue
// module id = null
// module chunks = 